/**
 * Tagesraster der Ressourcen (Board „Belegung · Ressourcen“): Zeilen 58 px mit Name und
 * Öffnungsfenster, Spalten je halbe Stunde, Zeit außerhalb des Fensters schraffiert. Ziehen markiert
 * eine Zeit; ein Klick auf einen Block öffnet die Bestätigung zum Aufheben.
 */
import type { ResourceOccupancyEntry, ResourceOccupancyRow } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { clockFromMinutes, SLOT_MINUTES } from '../resourceModel';
import type { GridAxis, GridSelection } from './resourceGridModel';
import { ResourceGridRow } from './ResourceGridRow';

interface Props {
  axis: GridAxis;
  rows: ResourceOccupancyRow[];
  date: string;
  canManage: boolean;
  selection: GridSelection | null;
  onSelect: (selection: GridSelection) => void;
  onCancel: (entry: ResourceOccupancyEntry) => void;
}

export function ResourceGrid({ axis, rows, date, canManage, selection, ...props }: Props) {
  const columns = `repeat(${axis.slots}, minmax(0, 1fr))`;
  return (
    <div className="min-w-0">
      <div className="border-hairline flex border-b" aria-hidden>
        <div className="text-ink-soft flex w-[180px] shrink-0 items-center px-[18px] font-mono text-[10px] uppercase tracking-[0.14em]">
          Ressource
        </div>
        <div className="grid grow" style={{ gridTemplateColumns: columns }}>
          {Array.from({ length: axis.slots }, (_, index) => {
            const minute = axis.start + index * SLOT_MINUTES;
            return (
              <div
                key={minute}
                className={cn(
                  'text-ink-soft flex h-10 items-center pl-1 font-mono text-[11px]',
                  minute % 60 === 0 ? 'border-hairline border-l' : 'border-paper border-l',
                )}
              >
                {minute % 60 === 0 ? clockFromMinutes(minute).slice(0, 2) : ''}
              </div>
            );
          })}
        </div>
      </div>
      {rows.map((row) => (
        <ResourceGridRow
          key={row.resourceId}
          axis={axis}
          row={row}
          date={date}
          canManage={canManage}
          selection={selection?.resourceId === row.resourceId ? selection : null}
          {...props}
        />
      ))}
    </div>
  );
}
